import angular from 'angular'
import moment from 'moment-timezone'

angular
  .module('admin.channel_hero_banners.edit', [])
  .controller('ChannelHeroBannersEditCtrl', ChannelHeroBannersEditCtrl)

/** @ngInject */
function ChannelHeroBannersEditCtrl(
  $scope,
  $state,
  $timeout,
  $stateParams,
  ChannelHeroBannerService,
  EventService,
  UploadService,
) {
  var vm = this

  vm.model = {}
  vm.pathImgH = ''
  vm.pathImgM = ''
  vm.id = $stateParams.id
  vm.isOpen = false
  vm.isOpen2 = false
  vm.channels = []

  var isDate = function (date) {
    return new Date(date) !== 'Invalid Date' && !isNaN(new Date(date))
  }

  vm.openCalendar = function (e) {
    e.preventDefault()
    e.stopPropagation()

    vm.isOpen = true
  }

  vm.openCalendar2 = function (e) {
    e.preventDefault()
    e.stopPropagation()

    vm.isOpen2 = true
  }

  EventService.listChannels().then(function (result) {
    vm.channels = result.results
  })

  function load() {
    if (vm.id !== '0') {
      ChannelHeroBannerService.get(vm.id).then(function (result) {
        vm.model = result.results
        if (vm.model['ts-start']) {
          vm.model['ts-start'] = vm.model['ts-start'] / 1000
          vm.model['ts-start'] = new Date(parseInt(vm.model['ts-start']))
          vm.data1 = angular.copy(vm.model['ts-start'])
        }

        if (vm.model['ts-end']) {
          vm.model['ts-end'] = vm.model['ts-end'] / 1000
          vm.model['ts-end'] = new Date(parseInt(vm.model['ts-end']))
          vm.data2 = angular.copy(vm.model['ts-end'])
        }
      })
    }
  }

  load()

  vm.save = function () {
    var model = angular.copy(vm.model)
    var isUpdate = model.id !== undefined && model.id !== '' && model.id !== 0
    delete model.ts

    if (vm.data1 !== undefined && vm.data1 !== '' && vm.data1 !== null) {
      if (isDate(vm.data1)) {
        var date = parseInt(new Date(new Date(vm.data1).setSeconds(0)).getTime() * 1000)
        model['ts-start'] = date
      } else {
        swal('Date field invalid.', '', 'error')
        return
      }
    } else {
      model['ts-start'] = null
    }

    if (vm.data2 !== undefined && vm.data2 !== '' && vm.data2 !== null) {
      if (isDate(vm.data2)) {
        var date = parseInt(new Date(new Date(vm.data2).setSeconds(0)).getTime() * 1000)
        model['ts-end'] = date
      } else {
        swal('Date field invalid.', '', 'error')
        return
      }
    } else {
      model['ts-end'] = null
    }

    if (isUpdate) {
      ChannelHeroBannerService.update(model.id, model).then(
        function (result) {
          $state.go('admin.channel_hero_banners')
        },
        function (err) {
          $timeout(function () {
            swal(err.error.message, '', 'error')
          }, 200)
        },
      )
    } else {
      ChannelHeroBannerService.create(model).then(
        function (result) {
          $state.go('admin.channel_hero_banners')
        },
        function (err) {
          $timeout(function () {
            swal(err.error.message, '', 'error')
          }, 200)
        },
      )
    }
  }

  vm.cancel = function () {
    $state.go('admin.channel_hero_banners')
  }

  vm.uploadH = function (item) {
    if (vm.pathImgH.type === 'image/tiff') {
      swal('Unsupported extension', '', 'warning')
      return
    }

    vm.loadH = true
    UploadService.save('channel_hero_banners', vm.pathImgH, 'img-web', item.id).then(
      function (fileName) {
        vm.loadH = false
        item['img-web'] = fileName
      },
    )
  }

  vm.uploadM = function (item) {
    if (vm.pathImgM.type === 'image/tiff') {
      swal('Unsupported extension', '', 'warning')
      return
    }

    vm.loadM = true
    UploadService.save('channel_hero_banners', vm.pathImgM, 'img-mob', item.id).then(
      function (fileName) {
        vm.loadM = false
        item['img-mob'] = fileName
      },
    )
  }

  var watch1 = $scope.$watch('vm.data1', function (newVal, oldVal) {
    if (newVal === oldVal) {
      return
    }

    if (newVal === null) {
      return
    }

    if (newVal) {
      vm.timezoneDate1NY = moment(newVal).tz('America/New_York').format('MM/DD/YYYY HH:mm A')
      vm.timezoneDate1LA = moment(newVal).tz('America/Los_Angeles').format('MM/DD/YYYY HH:mm A')
    }
  })

  var watch2 = $scope.$watch('vm.data2', function (newVal, oldVal) {
    if (newVal === oldVal) {
      return
    }

    if (newVal === null) {
      return
    }

    if (newVal) {
      vm.timezoneDate2NY = moment(newVal).tz('America/New_York').format('MM/DD/YYYY HH:mm A')
      vm.timezoneDate2LA = moment(newVal).tz('America/Los_Angeles').format('MM/DD/YYYY HH:mm A')
    }
  })

  $scope.$on('$destroy', function () {
    watch1()
    watch2()
  })

  vm.openCalendar1 = function (e) {
    e.preventDefault()
    e.stopPropagation()

    vm.isOpen1 = true
  }

  vm.openCalendar2 = function (e) {
    e.preventDefault()
    e.stopPropagation()

    vm.isOpen2 = true
  }

  var isDate = function (date) {
    return new Date(date) !== 'Invalid Date' && !isNaN(new Date(date))
  }
}
